





































import { Component, Prop, Vue } from 'vue-property-decorator';
import InfoIcon from '@/components/icons/Info.vue';

export type CampaignSummaryListItem = {
  label?: string;
  amount?: number;
  sufixAmount?: string;
};

@Component({
  components: {
    InfoIcon
  }
})
export default class CampaignSummary extends Vue {
  @Prop({ default: '' }) footerText?: string;
  @Prop({ default: '' }) tooltipText?: string;
  @Prop({ default: () => [] }) list!: CampaignSummaryListItem[];
}
